/** RegExp to test whether it denotes a valid Internet Shortcut with a URL or not */ export const InternetShortcutRegExp = /URL=(.+)/;
// Undo and redo share this cooldown so alternating shortcuts cannot bypass the throttle.
export const UndoRedoThrottleIntervalMs = 500;
